// extracted by mini-css-extract-plugin
export var profile_menu = "ProfileMenu-module--profile_menu--kEXuR";
export var profile_menu_item = "ProfileMenu-module--profile_menu_item--uquet";
export var active = "ProfileMenu-module--active--pWkcZ";
export var count = "ProfileMenu-module--count--8+vXx";